import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
const CustomMarker = ({ SiteName, RegionName, NumberOfTrials, Position }) => {
    const icon = L.divIcon({
        className: 'custom-marker',
        html: `<div class="custom-marker-icon"><svg class="MuiSvgIcon-root custom-marker-icon" 
      aria-hidden="true" style="color: #246cb1; fill: #246cb1;" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"></path></svg></div>`
    });
    return (React.createElement(Marker, { position: Position, icon: icon },
        React.createElement(Popup, null,
            React.createElement(IconButton, { sx: { color: "#246cb1" } },
                React.createElement(LocationOnIcon, null)),
            React.createElement(Link, { to: `/?site=${SiteName}` }, SiteName),
            React.createElement("br", null),
            "Number of trials: ",
            NumberOfTrials)));
};
export default CustomMarker;
